import { Component, OnInit, Input } from '@angular/core';
import { Program } from 'app/shared/models/program';
import { parseUniverseList } from 'app/shared/utils/universes';

@Component({
  selector: 'app-card-program-details',
  templateUrl: './card-program-details.component.html',
  styleUrls: ['./card-program-details.component.sass']
})
export class CardProgramDetailsComponent implements OnInit {
  @Input() program: Program;

  isTermsOpen = false;

  constructor() { }

  ngOnInit() {}

  getUniverseList(universes) {
    return parseUniverseList(universes);
  }
}
